(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('bbpsMarkupDetailsController',bbpsMarkupDetailsController);

		bbpsMarkupDetailsController.$inject = ['$scope', 'MarkupReport'];

    function bbpsMarkupDetailsController ($scope,MarkupReport ) {
        var vm = this;

        bbpsMarkupDetailsFile();

   function bbpsMarkupDetailsFile(){
	   MarkupReport.getBBPSMarkupDetails(function(result){
                vm.bbpsMarkupDetails = result.data;
				previewTACForArray( vm.bbpsMarkupDetails, 'BBPS_Markup_Details.pdf');
				
	   })
	
    }
    function previewTACForArray(arrayBuffer, pdfFileName) {
    var file = new Blob([arrayBuffer], { type: 'application/pdf' });
    var fileURL = URL.createObjectURL(file);

    // instead of opening new window, show inside current page
    document.getElementById("pdfContainer").innerHTML =
        '<embed src="' + fileURL + '" type="application/pdf" width="100%" height="100%">';
}
}
})();